<template>
    <MainSlider
        :slides-data="slidesData"
        :additional-settings="additionalSettings"
        :user-region="userRegion"
        :disable-video-in-banners="disableVideoInBanners"
        :is-mobile="$isMobile"
    />
</template>

<script>
import {defineComponent, computed} from 'vue';
import {MainSectionSlider as MainSlider} from '@cibsite/ui-components-vue2';
import {useBannersStore} from '@/stores/banners';
import {useRegionsStore} from '@/stores/regions';

export default defineComponent({
    name: 'MainSectionSlider',
    components: {
        MainSlider,
    },
    props: {
        slidesData: {
            type: Array,
            required: true,
        },
        additionalSettings: {
            type: Object,
            default: () => ({}),
        },
    },
    setup() {
        const bannersStore = useBannersStore();
        const regionsStore = useRegionsStore();

        const disableVideoInBanners = computed(() => bannersStore.disableVideoInBanners);
        const userRegion = computed(() => regionsStore.userRegion);

        return {
            disableVideoInBanners,
            userRegion,
        };
    },
});
</script>
